import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { addDoc, collection } from "firebase/firestore";
import { db, auth } from "../../../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";

interface FormData {
  title: string;
  description: string;
}

export const CreatePostForm = () => {
  const schema = yup.object().shape({
    title: yup.string().required("Title cannot be empty!"),
    description: yup.string().required("Description cannot be empty!"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({ resolver: yupResolver(schema) });

  const navigate = useNavigate();

  const [user, loading, error] = useAuthState(auth);
  const postRef = collection(db, "posts");

  const onCreatePost = async (data: FormData) => {
    try {
      await addDoc(postRef, {
        // title: data.title,
        // description: data.description,
        ...data,
        username: user?.displayName,
        userId: user?.uid,
      });
      navigate("/");
    } catch (error) {}
  };

  return (
    <form onSubmit={handleSubmit(onCreatePost)} className='form w-50 mx-auto'>
      <div className='mb-3 w-50 d-flex flex-column align-items-start'>
        <label htmlFor='title' className='form-label'>
          Title:
        </label>
        <input placeholder='Title..' type='text' id='title' className='form-control' {...register("title")} />
        {errors.title && <p className='alert alert-danger py-1 my-1'>{errors.title?.message}</p>}
      </div>
      <div className='mb-3 d-flex flex-column align-items-start'>
        <label htmlFor='description' className='form-label'>
          Description:
        </label>
        <textarea placeholder='Description..' id='description' className='form-control' {...register("description")} />
        {errors.description && <p className='alert alert-danger py-1 my-1'>{errors.description?.message}</p>}
      </div>
      <input type='submit' className='btn btn-success' value='Create Post' />
    </form>
  );
};
